export default {
      id: "i-google-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "img/sprite.svg#i-google",
      toString: function () {
        return this.url;
      }
    }